module.exports = __webpack_public_path__ + "static/img/img23.4fd4fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community/img23.png
// module id = w8g6
// module chunks = 1